/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PagarMeAddressResponse {
  city?: string;
  country?: string;
  createdAt?: string;
  id?: string;
  line1?: string;
  line2?: string;
  state?: string;
  status?: string;
  updatedAt?: string;
  zipCode?: string;
}
